import './polyfills.js'
import React from 'react'
import ReactDOM from 'react-dom'
//import reportWebVitals from './reportWebVitals'
import App from './App'
import './styles/index.scss'
import './config/i18n'

// NOTE: react-bootstrap launch some warnings when render in StrictMode

/*ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
)*/

ReactDOM.render(
  <App />,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals()
